import { ConfigType } from "../utils/requestAPI";

const scrape = {
  getScrape: (link: string, landlordId: any): ConfigType => {
    return {
      method: "post",
      url: "properties/details",
      data: {
        link,
        landlord: landlordId,
      },
    };
  },

  saveScraped: (data: any): ConfigType => {
    return {
      method: "post",
      url: "properties/save-scraped",
      data,
    };
  },
};

export default scrape;
